import AppToggle from '@components/Toggle'

export default {

    components: {
        AppToggle,
    },

    props: {
        dataItem: {
            type: Object,
            required: true,
        },
    },

    computed: {
        item() {
            return this.dataItem
        },
    },

}
